<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Confirmação para desvincular</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>
      <div class="c-modalCard__body">
        Tem certeza de que deseja desvincular esta conta?
      </div>
      <footer class="c-modalCard__footer">
        <button type="button" class="btn"  v-on:click="isVisible = false">Não</button>
        <button type="button" class="btn btn--success" @click="confirm()">Sim</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  export default {
    data: () => ({
      modal: null,
      isVisible: false
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      callback: {
        type: Function,
        required: false
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      confirm () {
        this.$emit('saveUserRoles', true)
        this.close()
      },
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick
        this.isVisible = false
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ModalUnlink.vue?2182f2e7